// extracted by mini-css-extract-plugin
module.exports = {"header":"list_header__1ped9","heading":"list_heading__SQ2Yr","header-buttons":"list_header-buttons__1h-rP"};